<div class="login-wrapper">
  <div class="login-bg"></div>

  <div class="login-content">
    <div class="brand-header">
      <img src="assets/logo.png" alt="Porra Mundial 2026" class="brand-logo" />
      <span class="brand-name">PORRA MUNDIAL 2026</span>
    </div>

    <div class="form-card">
      <div class="form-card-inner">
        <h2 class="form-title">Iniciar sesión</h2>
        <p class="form-subtitle">Vuelve al partido, crack.</p>

        <div class="field-group">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Email</mat-label>
            <input
              matInput
              type="email"
              autocomplete="email"
              [(ngModel)]="username"
              (keyup.enter)="login()"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Contraseña</mat-label>
            <input
              [type]="hidePassword ? 'password' : 'text'"
              matInput
              autocomplete="current-password"
              [(ngModel)]="password"
              (keyup.enter)="login()"
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              [attr.aria-label]="
                hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'
              "
              [attr.aria-pressed]="!hidePassword"
              (click)="hidePassword = !hidePassword"
            >
              <mat-icon>{{
                hidePassword ? "visibility" : "visibility_off"
              }}</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <button
          mat-flat-button
          color="primary"
          class="btn-login"
          (click)="login()"
        >
          Entrar
        </button>

        <div class="form-links">
          <button mat-button (click)="showRegister()" class="link-btn">
            ¿Eres nuevo? Regístrate
          </button>
          <span class="link-sep" aria-hidden="true">·</span>
          <button mat-button (click)="showRestore()" class="link-btn">
            ¿Olvidaste tu contraseña?
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<block-ui></block-ui>
